import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useContext } from 'react';
import { Flex } from '@chakra-ui/react';
import { SizeContext } from "../../../atoms/contexts/SizeContext";
import { getSizedRootStyles } from "./CardVlp.styles";
import { PraxisVlp } from "./PraxisVlp";
import { BricoVlp } from "./BricoVlp";
import { PRAXIS } from "../../../index.js";
export var getInnerComponent = function getInnerComponent(format, lang, text) {
  if (format === PRAXIS) return /*#__PURE__*/React.createElement(PraxisVlp, {
    text: text,
    "data-testid": "molecules-CardVlp-PraxisVlp"
  });
  return /*#__PURE__*/React.createElement(BricoVlp, {
    variant: lang,
    text: text
  });
};
export var CardVlp = function CardVlp(_ref) {
  var children = _ref.children;
  var _useContext = useContext(SizeContext),
    _useContext$sizes = _useContext.sizes,
    sizes = _useContext$sizes === void 0 ? ['sm', 'lg'] : _useContext$sizes;
  if (!sizes || !sizes.length) return null;
  return /*#__PURE__*/React.createElement(Flex, {
    zIndex: 1,
    height: "fit-content",
    flexGrow: 0,
    sx: _objectSpread({}, getSizedRootStyles(sizes))
  }, children);
};